import React, { Component } from 'react';
import { has, map } from 'lodash';
import DriverEmergencyHeader from './DriverEmergencyHeader';
import Button from '../common/Button';
import { imageBasePath, appBasePath } from '../../constants/staticData';
import io from 'socket.io-client';
import { BASE_URL } from '../../constants/api';

export default class DriverEmergencyRequestList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropDownVisible: true,
      dropDownVisiblewait: true,
      driverStatus: 1
    };
    this.timeFormate = this.timeFormate.bind(this);
    this.goOnline = this.goOnline.bind(this);
    this.redirection = this.redirection.bind(this);
  }

  componentWillMount() {
    const authData = JSON.parse(localStorage.getItem('businessAuthData'));
    this.setState({ driverStatus: authData.driverStatus });
  }
  componentWillReceiveProps(nextProps) {
    const authData = JSON.parse(localStorage.getItem('businessAuthData'));
    this.setState({ driverStatus: authData.driverStatus });
  }

  goOnline() {
    this.props.actions.driverOnlineOfflineMode(1, this.props.router);
  }

  timeFormate(date) {
    //this.checkAcceptFlag();
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    let strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
  }
  redirection(requestID) {
    map(this.props.driveremergencyReducer.driveremergencyinfo.data, (info, index) => {
      if (requestID == info.garagejobquotes.userbookingrequest.requestid) {
        if (info.jobdetailstatusId == 9 || info.jobdetailstatusId == 10) {
          this.props.router.push(appBasePath + '/driver-AcceptDecline/' + requestID);
        } else if (info.jobdetailstatusId == 11) {
          this.props.router.push(appBasePath + '/driver-CompleteJob/' + requestID);
        }
      }
    });
  }

  render() {
    const { authReducer, commonReducer, driveremergencyReducer, manageuserReducer } = this.props;
    const drievrJobList = driveremergencyReducer.driveremergencyinfo.data;
    // const authData = JSON.parse(localStorage.getItem('businessAuthData'));
    //const driverstatus = authData.driverStatus ? authData.driverStatus : 1 ;
    return (
      <div className="driver-emergency-list-container">
        <div className="driver-emergency-main-body">
          <div id="demo" />
          {((!drievrJobList && this.state.driverStatus != 3) || manageuserReducer.displayloader == true) &&
            <div className="page-loader">
              <div className="loader-image">
                <img src={`${imageBasePath}/loader.gif`} />
              </div>
            </div>}
          {drievrJobList &&
            <div>
              {drievrJobList.length > 0 &&
                this.state.driverStatus != 3 &&
                manageuserReducer.displayloader == false &&
                <div className="container-fluid">
                  <div className="row clearfix">
                    <div
                      className="col-xs-12 container-fluid"
                      onClick={() => {
                        this.setState({ dropDownVisible: this.state.dropDownVisible ? false : true });
                      }}
                    >
                      <h5>
                        Queue
                        <span>
                          {this.state.dropDownVisible && <i className="mdi mdi-chevron-up" />}
                          {!this.state.dropDownVisible && <i className="mdi mdi-chevron-down" />}
                        </span>
                      </h5>
                    </div>
                    {this.state.dropDownVisible &&
                      map(drievrJobList, (info, index) => {
                        let DriverInformation = info.garagejobquotes.userbookingrequest;
                        let Actualtime = new Date(DriverInformation.createdAt);

                        return (
                          <div
                            className="col-xs-11 col-md-3 container-fluid emergency-type-list"
                            onClick={() => {
                              this.redirection(DriverInformation.requestid);
                            }}
                          >
                            <div className="emergency-type-info">
                              <div className="col-xs-12 container-fluid">
                                <div className="col-xs-6 emergency-type-data emergency-type-cutomer-name">
                                  {DriverInformation.username}
                                </div>
                                <div className="col-xs-6 text-right emergency-type-data emergency-kilo">
                                  {DriverInformation.distance.toFixed(2)}KM
                                </div>
                              </div>
                              <div className="col-xs-12 container-fluid">
                                <div className="col-xs-6 emergency-type-data emergency-type-time">
                                  {info.garagejobquotes.garagejobquotesdetail[0].parent.name}
                                </div>
                                <div className="col-xs-6 text-right emergency-type-data emergency-type-time">
                                  {this.timeFormate(Actualtime)}
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>}
              {drievrJobList.length == 0 &&
                this.state.driverStatus != 3 &&
                manageuserReducer.displayloader == false &&
                <div className="empty-list-display">

                  <img src={`${imageBasePath}/no_jobs.png`} alt="No Job for you" />
                  <h5>Looks like you have no jobs in queue</h5>
                </div>}
            </div>}
          {this.state.driverStatus == 3 &&
            manageuserReducer.displayloader == false &&
            <div className="empty-list-display">
              <img src={`${imageBasePath}/empty.png`} alt="No Job for you" />
              <h5>you can't recieve jobs in offline mode</h5>
              <Button
                btnType="label"
                btnSize="sm"
                fontSize={16}
                label="Go Online"
                btnCallBack={() => this.goOnline(this)}
                customClass="btn-add-user mobile-view-go-online"
              />
            </div>}
          {/*driveremergencyReducer.driveremergencyinfo.waiting.length>0 && <div className="container-fluid">
             <div className="row clearfix">
              <div className="col-xs-12 container-fluid" onClick={() => {this.setState({dropDownVisiblewait: this.state.dropDownVisiblewait ? false : true});}}>
               <h5>Waiting
               <span>
                {this.state.dropDownVisiblewait && <i className="mdi mdi-chevron-up" />}
                {!this.state.dropDownVisiblewait && <i className="mdi mdi-chevron-down" />}
                </span>
                </h5>
              </div>
              {this.state.dropDownVisiblewait && map(driveremergencyReducer.driveremergencyinfo.waiting
                 , (info, index) => {
                      return (
                <div className="col-xs-11 col-md-3 container-fluid emergency-type-list">
                  <div className="emergency-type-info">
                   <div className="col-xs-6 emergency-type-data emergency-type-cutomer-name">{info.customerName}</div>
                   <div className="col-xs-6 text-right emergency-type-data">{info.distance}</div>
                   <div className="col-xs-6 emergency-type-data">{info.emergencyType}</div>
                   <div className="col-xs-6 text-right emergency-type-data">{time}</div>
                  </div>
                </div>)})}
               </div>
              </div>
             */}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DriverEmergency/DriverEmergencyRequestList.jsx